import React from 'react';
import { Offcanvas as BootstrapOffcanvas } from 'react-bootstrap';

const Offcanvas = ({ 
    children, 
    show = false, 
    onHide, 
    title, 
    placement = 'start', 
    backdrop = true,
    scroll = false,
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    return (
        <BootstrapOffcanvas 
            show={show} 
            onHide={onHide} 
            placement={placement}
            backdrop={backdrop}
            scroll={scroll}
            className={className} 
            style={style}
            {...props}
        >
            {title && (
                <BootstrapOffcanvas.Header closeButton>
                    <BootstrapOffcanvas.Title>{title}</BootstrapOffcanvas.Title>
                </BootstrapOffcanvas.Header>
            )}
            <BootstrapOffcanvas.Body>{children}</BootstrapOffcanvas.Body>
        </BootstrapOffcanvas>
    );
};

export default Offcanvas;

